const publicUrl = process.env.PUBLIC_URL || "";

export const VERDICTIA_MARK_SRC = `${publicUrl}/verdictia-mark.svg`;
export const VERDICTIA_WORDMARK_SRC = `${publicUrl}/verdictia-wordmark.svg`;
export const VERDICTIA_WORDMARK_LIGHT_SRC = `${publicUrl}/verdictia-wordmark-light.svg`;
export const VERDICTIA_WORDMARK_DARK_SRC = `${publicUrl}/verdictia-wordmark-dark.svg`;
export const VERDICTIA_BRAND_NAME = "Verdictia";
